import { useContext } from 'react';
import { AppContext } from './AppContext';
import type { Broker, Account } from '../types';

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppProvider');
  return ctx;
}

export function useSelectedBroker(): Broker | null {
  const { state } = useAppContext();
  return state.brokers.find((b) => b.id === state.selectedBrokerId) ?? null;
}

export function useSelectedAccount(): Account | null {
  const { state } = useAppContext();
  const broker = state.brokers.find((b) => b.id === state.selectedBrokerId);
  if (!broker) return null;
  return broker.accounts.find((a) => a.accountId === state.selectedAccountId) ?? null;
}
